module.exports = __webpack_public_path__ + "img/office-5.277b0131.png";